import { getVehicleByUrl } from "./rpcVehicleData";

/**
 * Filter vehicle data based on make/model of given vehicle.
 *
 * @param {string} url - Url of the vehicle.
 * @param {Function} setSingleVehicleData - Function to set single vehicle data
 */

export default async function getSingleVehicleDataFromDatabase({
  url,
  setVehicleData,
}) {
  if (!url) {
    return [];
  }

  const vehicleData = await getVehicleByUrl(url);

  if (vehicleData) {
    setVehicleData((prevVehicleData) => ({
      ...prevVehicleData,
      year: vehicleData.year,
      make: vehicleData.make,
      model: vehicleData.model,
      mileage: vehicleData.miles,
      bid_price: vehicleData.bid_price,
      prediction: vehicleData.prediction,
      image: vehicleData.image,
    }));
  }

  // Return data just in case we want to use it right away
  return vehicleData || [];
}
